import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const logos = [
    { src: '/logos/nic.png', alt: 'National Institute of Chemistry', link: 'https://www.ki.si' },
    { src: '/logos/syngen.png', alt: 'SynGen', link: '#' },
    { src: '/logos/kit.png', alt: 'KIT', link: 'https://www.kit.edu' }
  ];

  const quickLinks = [
    { name: 'Research', path: '/research' },
    { name: 'Publications', path: '/publications' },
    { name: 'Team', path: '/team' },
  ];

  const contactLinks = [
    { name: 'Join Us', path: '/join-us' },
    { name: 'Contact', path: '/contact' },
    { name: 'Collaborators', path: '/collaborators' },
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* About Section */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold mb-4">Modic Lab</h3>
            <p className="text-gray-400 mb-4">
              Decoding RNA networks to understand the fundamental roles RNA molecules play in development and disease.
            </p>
            <div className="flex space-x-4">
              <a href="mailto:modic@kit.edu" className="text-gray-400 hover:text-white transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-gray-400 hover:text-white transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Connect</h4>
            <ul className="space-y-2">
              {contactLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-gray-400 hover:text-white transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Institution Logos */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-wrap justify-center items-center gap-12 mb-8">
            {logos.map((logo, index) => (
              <a 
                key={index} 
                href={logo.link} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="opacity-80 hover:opacity-100 transition-opacity duration-300"
              >
                <img 
                  src={logo.src} 
                  alt={logo.alt} 
                  className="h-16 max-w-[180px] object-contain"
                />
              </a>
            ))}
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center text-gray-500 mt-8 pt-8 border-t border-gray-800 text-sm">
          <p>© {new Date().getFullYear()} Modic Lab. All rights reserved.</p>
          <p className="mt-2">
            This website is privately hosted and not officially endorsed by KIT.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
